module.exports = __webpack_public_path__ + "static/elephant-2-263f8aa648610c2864c1b2a9140f252d.jpg";